import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  background-color: var(--nightBlue);
  width: 100%;
  height: 4rem;
  padding: 0 var(--global-padding);

  border-image: linear-gradient(var(--gradient)) 1;
  border-bottom: 0.1rem solid;

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--thunderCloudGrey);
    margin: 0 auto;
    height: 100%;
    & > div {
      display: flex;
      align-items: center;
    }
  }
`;

export const MoviePickerLogo = styled.img`
  max-height: 1.5rem;
  width: auto;
`;

export const NoAvatarImg = styled.img`
  width: 2rem;
  height: 2rem;
  border: 1px solid var(--thunderCloudGrey);
  border-radius: 50%;
`;
